import {TheRaveSymbol} from "./TheRaveSymbol";
import {TheRaveSymbolState} from "./TheRaveSymbolConfig";
import {TheRave} from "../TheRave";
import {TimelineLite} from "gsap";
import {TheRaveSound} from "../sound/TheRaveSound";
import {Layers, TheRaveLayers} from "../view/TheRaveLayers";
import {Helper} from "../../core/utils/Helper";
import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";

export class TheRaveXWaysSymbol extends TheRaveSymbol {
    private _animationContainer: PIXI.Container;
    constructor(symbolName: string, reelId: number, initState: TheRaveSymbolState, symHeight: number = 150, linkedNum: number = 1) {
        super(symbolName, reelId, initState);
        this._animationContainer = new PIXI.Container();
    }

    public playLanding(init: boolean = false): TimelineLite {
        const tl: TimelineLite = new TimelineLite(),
            blend: PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(`XWAYSblend`)),
            normal: PIXI.spine.Spine = new PIXI.spine.Spine(TheRave.assetLoader.getSpineAsset(`XWAYSnormal`));
        blend.name = `XWAYSblend`;
        normal.name = `normal`;
        TheRaveLayers.getLayer(Layers.SYMBOL_LANDING)!.addChild(this._animationContainer);
        this._animationContainer.position = Helper.copyLocalPosition(this._animationContainer,this);
        tl.add([
            () => {
                TheRaveSound.playSoundEffect(TheRaveSound.XWAY_SYMBOL_LANDING);
                blend.state.setAnimation(0, "landing", false);
                normal.state.setAnimation(0, "landing", false)
                this._animationContainer.addChild(normal);
                this._animationContainer.addChild(blend);
            }
        ], 0.2);
        tl.add(()=>{TheRaveLayers.getLayer(Layers.SYMBOL_LANDING)!.removeChild(this._animationContainer);}, 0.933)
        return tl;
    }
}